module.exports = __webpack_public_path__ + "static/media/julian_mair.22a491d4.pdf";